import { ACTIONS } from 'src/app/core/utils/actions.constants';
import { COMMONS } from 'src/app/core/utils/commons.constants';

export const TURN = {
  id: 'common.turn',
  title: 'Turnos',

  labels: {
    ...COMMONS,
    patient: 'Paciente',
    doctor: 'Doctor',
    specialty: 'Especialidad',
    status: 'Estado del Turno',
    age: 'Edad',
    comments: 'Comentarios',
    newSuccess: 'Nuevo turno generado.',
    patchSuccess: 'Turno reasignado.',
    dateTime: 'Fecha y Hora',
    endDateTime: '(Fin)',
    turn: 'Turno',
    balance: 'Saldo Pendiente'
  },

  actions: {
    ...ACTIONS,
    add: `${ACTIONS.add} Turno`,
    addPatient: `${ACTIONS.add} Paciente`,
    search: 'Buscar paciente',
    vitalSign: 'Registro signos vitales',
    care: 'Atender Consulta',
    updateStatus: `${ACTIONS.edit} Estado`,
    updateDoctor: `${ACTIONS.edit} Doctor`,
    addComment: 'Agregar comentarios',
    seeOldTurns: 'Turnos antiguos',
    editConsult: `Ver/${ACTIONS.edit} Consulta`
  }
};
